export default {"src":"/evde-internet/_next/static/media/chevronRight.838ab0cc.svg","height":24,"width":24};